import React, { FC, MouseEvent, ReactNode } from 'react';
import classNames from 'classnames';
import { createStyles, withStyles, darken, Theme, WithStyles } from '@material-ui/core/styles';

import i18n from 'config/i18n';

import { Button, Dialog, DialogActions, DialogContent, Typography } from '@material-ui/core';

const defaultProps = {
  message: i18n.t('components:alertMessage'),
  cancel: i18n.t('common:cancel'),
  confirm: i18n.t('common:confirm'),
};

const styles = ({ palette, spacing }: Theme) =>
  createStyles({
    content: {
      padding: spacing(5),
      '&:first-child': {
        paddingTop: spacing(5),
      },
    },
    button: {
      width: 170,
      padding: `${spacing(2)}px ${spacing(3)}px`,
      textAlign: 'center',
    },
    delete: {
      backgroundColor: palette.error.main,
      borderColor: palette.error.main,
      '&:hover': {
        backgroundColor: darken(palette.error.main, 0.1),
        '@media (hover: none)': {
          backgroundColor: palette.error.main,
        },
      },
    },
    actions: {
      margin: `${spacing(4)}px 0 0 0`,
      justifyContent: 'space-evenly',
    },
  });

interface IProps extends WithStyles<typeof styles> {
  open: boolean;
  onConfirm: (event: MouseEvent<HTMLButtonElement>) => void;
  onCancel: () => void;
  message?: string | ReactNode;
  cancel?: string | ReactNode;
  confirm?: string | ReactNode;
}

const Alert: FC<IProps> = ({ open, classes, onConfirm, onCancel, message, cancel, confirm }) => (
  <Dialog open={open} onClose={onCancel}>
    <DialogContent className={classes.content}>
      <Typography gutterBottom align="center" variant="subtitle2">
        {message}
      </Typography>
      <DialogActions className={classes.actions}>
        <Button size="large" variant="contained" onClick={onCancel} className={classes.button}>
          {cancel}
        </Button>
        <Button
          size="large"
          color="primary"
          variant="contained"
          onClick={onConfirm}
          autoFocus
          className={classNames(classes.button, classes.delete)}>
          {confirm}
        </Button>
      </DialogActions>
    </DialogContent>
  </Dialog>
);

Alert.defaultProps = defaultProps;

export default withStyles(styles)(Alert);
